/*
* @Author: babysoft08
* @Date:   2025-06-21 16:35:50
* @Last Modified by:   babysoft08
* @Last Modified time: 2025-06-21 16:36:01
*/
import React, { useState, useRef, useEffect } from 'react';
import './Tooltip.css';

const Tooltip = ({ message, children }) => {
  const [visible, setVisible] = useState(false);
  const ref = useRef();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  return (
    <span className="tooltip-wrapper" ref={ref}>
      <span onClick={() => setVisible(!visible)} className="tooltip-icon">
        {children}
      </span>
      {visible && <span className="tooltip-box">{message}</span>}
    </span>
  );
};

export default Tooltip;